import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
    title: {
        id: 'phone_confirm.title',
        defaultMessage: 'Подтверждение номера телефона'
    },
    phone: {
        id: 'phone_confirm.phone',
        defaultMessage: 'Мобильный телефон'
    },
    confirmButton: {
        id: 'phone_confirm.confirm_button',
        defaultMessage: 'Подтвердить'
    },
    confirmationCode: {
        id: 'phone_confirm.confirmation_code',
        defaultMessage: 'Код подтверждения'
    },
    smsReceivedText: {
        id: 'phone_confirm.sms_received_text',
        defaultMessage: 'Введите код из SMS сообщения, высланного на номер {phone}'
    },
    denial: {
        id: 'phone_confirm.denial',
        defaultMessage: 'Не желаю участвовать в акции, просто зарегистрируйте мне счет'
    },
    confirmationError: {
        id: 'phone_confirm.errors.confirmation_fail',
        defaultMessage: 'Ошибка при подтверждении'
    }
});

export default class extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        gamblerId: React.PropTypes.number.isRequired,
        phone: React.PropTypes.string,
        phoneConfirming: React.PropTypes.bool.isRequired,
        phoneConfirmationError: React.PropTypes.any,
        confirmPhone: React.PropTypes.func.isRequired,
        denyConfirmationCallback: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this._handleCodeConfirmClick = this._handleCodeConfirmClick.bind(this);
        this._onChangeCode = this._onChangeCode.bind(this);
    }

    _onChangeCode(e) {
        e.preventDefault();

        const code = e.target.value;
        let isValid = true;
        for (let offset = 0; offset < code.length; offset++) {
            const charCode = parseInt(code[offset].charCodeAt());
            if (!((charCode > 47 && charCode < 58) ||
                (charCode > 64 && charCode < 91) ||
                (charCode > 96 && charCode < 123))) {
                isValid = false;
            }
        }
        if (isValid) {
            e.target.value = e.target.value.toUpperCase();
        } else {
            e.target.value = e.target.value.substring(0, e.target.value.length - 1);
        }
    }

    _handleCodeConfirmClick(e) {
        e.preventDefault();

        const gamblerId = this.props.gamblerId;

        const codeVal = this.refs.code.value;
        if (codeVal) {
            this.props.confirmPhone({gamblerId, code: codeVal.toUpperCase(), authorize: true});
        }
    }

    render() {
        const {phone, phoneConfirming, phoneConfirmationError} = this.props;
        const denialLinkStyle = {color:'#186b38'};
        const codeStyle = {textTransform: 'uppercase'};

        return (
            <div className="modal--dialog">
                <div className="modal--header">
                    <div className="header-inner--logotype__link"></div>
                    <div className="header-inner__title">
                        <FormattedMessage {...messages.title}/>
                    </div>
                </div>
                <div className="modal--content">
                    <div className="modal--content__wrapper">
                        <div className="login--form form">
                            <p className="plain-text__paragraph">
                                <FormattedMessage {...messages.smsReceivedText} values={{phone}}/>
                            </p>
                            {phoneConfirmationError &&
                            <div className="error-message">
                                <FormattedMessage {...messages.confirmationError} />
                            </div>}
                            <div className="login--form__row form__row">
                                {phoneConfirming && <i>...spinner...</i>}
                                <label className="login--form__label form__label">
                                    &nbsp;
                                </label>
                                <input ref="code" onChange={this._onChangeCode} style={codeStyle} className="login--form__control form__control"/>
                            </div>
                            <div className="login--form__row form__row">
                                <button className="login--form__btn login--form__btn__js form__btn"
                                        onClick={this._handleCodeConfirmClick}>
                                    <FormattedMessage {...messages.confirmButton} />
                                </button>
                            </div>
                            <div className="login--form__row form__row">
                                <a href="#" className="login--form__btn login--form__btn__js" style={denialLinkStyle}
                                   onClick={this.props.denyConfirmationCallback}>
                                    <FormattedMessage {...messages.denial} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/shared/components/PhoneConfirmation/CodeInput.jsx